var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticStyle:{"height":"calc(100vh - 3.5rem)"}},[_c('div',{staticStyle:{"padding":"20px"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }